exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__Form__FormEmail,\n.DS__Form__Submit {\n  all: initial;\n  font-family: var(--font-family);\n}\n\n.DS__Form__FormEmail {\n  position: relative;\n  display: block;\n}\n\n.DS__Form__Submit {\n  position: absolute;\n  top: calc(50% - 20px);\n  right: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  font-size: 0;\n  cursor: pointer;\n  background-color: #ffffff;\n}\n\n.DS__Form__Submit:disabled {\n    opacity: 0.7;\n  }\n", ""]);

// exports
exports.locals = {
	"FormEmail": "DS__Form__FormEmail",
	"Submit": "DS__Form__Submit"
};